/**
 * @desc: Copied from https://git.perkbox.io/backend-services/company-values/blob/master/internal/errors.go
 */
var CompanyValues;
(function (CompanyValues) {
    CompanyValues["ErrUnknown"] = "PBCPVUnknown";
    CompanyValues["ErrUnauthorized"] = "PBCPVUnauthorized";
    CompanyValues["ErrNotFound"] = "PBCPVNotFound";
    CompanyValues["ErrInvalidArguments"] = "PBCPVInvalidArguments";
    CompanyValues["ErrAlreadyExists"] = "PBCPVAlreadyExists";
    CompanyValues["ErrDBPing"] = "PBCPVDBPing";
})(CompanyValues || (CompanyValues = {}));
export default CompanyValues;
